import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { PropertyMessageTagValidation } from 'uplisting-frontend/validations';

export default class PropertyMessageTagRepositoryService extends BaseRepositoryService<
  ModelRegistry['property-message-tag']
> {
  recordName = 'property-message-tag';
  implementMethods = ['buildChangeset'];

  validation = PropertyMessageTagValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/property-message-tag': PropertyMessageTagRepositoryService;
  }
}
